// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","647":"component---src-pages-markdown-remark-frontmatter-slug-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"6d6515f1cdc0f9662322","647":"6047e018bf8684d232f7","678":"0e10c522e692f7d7b240","883":"eb1e8dbe52a645ae78e3"}[chunkId] + ".js";
};